export default __webpack_public_path__ + "static/icon-extra-support-3513a72508ba2c55d3fd52d5dfd4f9cf.webp";